import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ApplicationSubmodulesFacade } from '@kros-sk/application-submodules';
import { SchemaRootOutletComponent } from '@kros-sk/core/schema';

@Component({
  selector: 'kros-module-shell',
  imports: [SchemaRootOutletComponent],
  templateUrl: './module-shell.component.html',
  styleUrl: './module-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModuleShellComponent {
  readonly #store = inject(ApplicationSubmodulesFacade);

  protected readonly state = this.#store.currentSchemaState;
}
